let selectedUid = null;
let isApproved = false;
const listeners = new Set();
const approvalListeners = new Set();

// Set the selected UID with validation
export const setSelectedUid = (uid) => {
  if (uid && typeof uid === 'string') {
    selectedUid = uid;
    // Store in sessionStorage for persistence
    sessionStorage.setItem('selectedUid', uid);
    // console.log('[UidListener] Selected UID set:', uid);
    notifyListeners();
  } else {
    // console.warn('[UidListener] Invalid UID provided:', uid);
  }
};

// Set approval status with validation
export const setApprovedStatus = (status) => {
  const previousStatus = isApproved;
  isApproved = Boolean(status);
  sessionStorage.setItem('isApproved', String(isApproved));
  
  if (previousStatus !== isApproved) {
    // console.log('[UidListener] Approval status changed:', isApproved);
    notifyListeners();
    notifyApprovalListeners();
  }
};

// Get the selected UID with fallback to sessionStorage
export const getSelectedUid = () => {
  if (!selectedUid) {
    // Try to restore from sessionStorage
    const storedUid = sessionStorage.getItem('selectedUid');
    if (storedUid) {
      selectedUid = storedUid;
      // console.log('[UidListener] Restored UID from session:', storedUid);
    }
  }
  return selectedUid;
};

// Get approval status with fallback to sessionStorage
export const getIsApproved = () => {
  if (selectedUid && !isApproved) {
    // Try to restore from sessionStorage
    const storedStatus = sessionStorage.getItem('isApproved');
    if (storedStatus) {
      isApproved = storedStatus === 'true';
    }
  }
  return isApproved;
};

// Check if a valid UID is selected
export const hasSelectedUid = () => {
  return Boolean(getSelectedUid());
};

// Clear the selected UID
export const clearSelectedUid = () => {
  selectedUid = null;
  isApproved = false;
  sessionStorage.removeItem('selectedUid');
  sessionStorage.removeItem('isApproved');
  // console.log('[UidListener] UID cleared');
  notifyListeners();
  notifyApprovalListeners();
};

// Add a listener for UID changes
export const addUidListener = (listener) => {
  if (typeof listener === 'function') {
    listeners.add(listener);
    // Immediately notify the new listener of current state
    listener(selectedUid, isApproved);
    return () => listeners.delete(listener);
  }
  // console.warn('[UidListener] Invalid listener provided');
  return () => {};
};

// Add a listener specifically for approval status changes
export const addApprovalListener = (listener) => {
  if (typeof listener === 'function') {
    approvalListeners.add(listener);
    // Immediately notify the new listener of current state
    listener(isApproved);
    return () => approvalListeners.delete(listener);
  }
  return () => {};
};

// Notify all UID listeners
const notifyListeners = () => {
  listeners.forEach((listener) => {
    try {
      listener(selectedUid, isApproved);
    } catch (error) {
      // console.error('[UidListener] Error in listener:', error);
    }
  });
};

// Notify all approval listeners
const notifyApprovalListeners = () => {
  approvalListeners.forEach((listener) => {
    try {
      listener(isApproved);
    } catch (error) {
      // console.error('[UidListener] Error in approval listener:', error);
    }
  });
};

